import   axios                         from 'axios';

import { API_URLS                   }  from '../urls';

import { BackendResponse            ,
         handleError                }  from '../../dataTypes/backendServicesManagment/types';

import { Configuration   }  from '../../dataTypes/configurationManagment/types';


export interface BackendResponse_Configuration extends BackendResponse<Configuration> {}

export const getConfiguration = async (): Promise<BackendResponse_Configuration> => {

  const url = API_URLS.getConfiguration;

  try
   {
    const response = await axios.get(url);

    if (response.status === 200)
          {
		   const data : Configuration = {
  svod                 : response.data.svod,
  broadcasting         : response.data.broadcasting,
  restream             : response.data.restream,
  shop                 : response.data.shop,
  salesCampaign        : response.data.salesCampaign,
  advertiserManagement : response.data.advertiserManagement,
  AICompanion          : response.data.AICompanion,
  poll                 : response.data.poll,
  chat                 : response.data.chat,
		   }
			  
           return {
                    code: 1,
                    comment: 'Les informations de configuration ont été récupérées avec succès.',
                    payload: data,
                  };
          }
     else {
           return handleError<Configuration>(response.status, 'Réponse non-200 de l\'API');
          }
   }
  catch (error)
   {
    console.log(url, error);

    if (axios.isAxiosError(error))
     {
      return handleError<Configuration>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<Configuration>(-102, 'Erreur inconnue');
  }
};

export const patchConfiguration = async ( svodB                 : boolean ,
                                          broadcastingB         : boolean ,
                                          restreamB             : boolean ,
                                          shopB                 : boolean ,
                                          salesCampaignB        : boolean ,
                                          advertiserManagementB : boolean ,
                                          AICompanionB          : boolean , 
                                          pollB                 : boolean ,
                                          chatB                 : boolean ): Promise<BackendResponse> => {

  const svod                 = svodB                 ? 1 : 0
  const broadcasting         = broadcastingB         ? 1 : 0
  const restream             = restreamB             ? 1 : 0
  const shop                 = shopB                 ? 1 : 0
  const salesCampaign        = salesCampaignB        ? 1 : 0
  const advertiserManagement = advertiserManagementB ? 1 : 0
  const AICompanion          = AICompanionB          ? 1 : 0
  const poll                 = pollB                 ? 1 : 0
  const chat                 = chatB                 ? 1 : 0                                      
  
  const url = API_URLS.patchConfiguration;

  try
   {
    const response = await axios.patch ( url , { svod                 ,
                                                 broadcasting         ,
                                                 restream             ,
                                                 shop                 ,
                                                 salesCampaign        ,
                                                 advertiserManagement ,
                                                 AICompanion          , 
                                                 poll                 ,
                                                 chat                 }, 
											   { headers: { 'Content-Type': 'application/merge-patch+json' } } );  

    console.log ('patchConfiguration', url, response)

    if (response.status === 200 || response.status === 204 || response.status === 201) 
	      {
           return {
                    code    : 1,
                    comment : 'Configuration updated successfully.',
                    payload : {} as any
                  };
          } 
	 else {
           return handleError<void>(response.status, 'Non-200/201/204 response from API');
          }
   } 
  catch (error) 
   {
    if (axios.isAxiosError(error)) 
	 {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<void>(-102, 'Unknown error');
   }
};
